import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const pwaRedirectGuard: CanActivateFn = (route, state) => {
  const router: Router = inject(Router);

  return router.createUrlTree([route.params['newPath']]);
};
